import React, { useState, useRef, useEffect } from "react";
import PostPDF from "../../../services/PostPdf.js";
import { Dialog } from "@mui/material"
import InvoiceResponse from "../InvoiceResponse.jsx"
import SnackbarEx from "../../Helpers/SnackbarEx.jsx";
import DisplayPdf from "../DisplayPdf.jsx"
import SupplierConfirmDialog from "../SupplierConfirmDialog.jsx";

export default function BatchFile() {
    const [pdfFiles, setPdfFiles] = useState([])
    const [displayPdf, setDisplayPdf] = useState(null)
    const [load, setLoad] = useState(false)
    const [isDragging, setIsDragging] = useState(false)
    const [openResponseDialog, setOpenResponseDialog] = useState(false)
    const [responseData, setResponseData] = useState(null)
    const [currentFileIndex, setCurrentFileIndex] = useState(-1);
    const [processingDots, setProcessingDots] = useState(0);
    const [pendingConfig, setPendingConfig] = useState(null)
    const [detectOpen, setDetectOpen] = useState(false)
    const [detectLoading, setDetectLoading] = useState(false)
    const [detection, setDetection] = useState(null)
    const [awaitingConfirm, setAwaitingConfirm] = useState(false)

    const [openTestSnack, setOpenTestSnack] = useState({
        color: "",
        message: "",
        open: false
    })

    useEffect(() => {
        let intervalId;
        if (load) {
            intervalId = setInterval(() => {
                setProcessingDots(prevDots => (prevDots % 4) + 1);
            }, 420);
        } else {
            setProcessingDots(0);
        }
        return () => clearInterval(intervalId);
    }, [load]);

    useEffect(() => {
        if (awaitingConfirm || currentFileIndex < 0) return;
        if (currentFileIndex < pdfFiles.length) {
            detectForFile(pdfFiles[currentFileIndex]);
        } else if (pdfFiles.length > 0) {
            setLoad(false);
            setPdfFiles([]);
            setDisplayPdf(null);
            setCurrentFileIndex(-1)
            setPendingConfig(null)
            setOpenTestSnack({ color: "success", message: "All invoices processed!", open: true });
        }
    }, [currentFileIndex, awaitingConfirm]);

    const handleFile = ({ target }) => {
        const newFilesArray = Array.from(target.files);
        setPdfFiles(prevFiles => [...prevFiles, ...newFilesArray]);
    }

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = e.dataTransfer.files;
        if (droppedFiles.length > 0) {
            setPdfFiles(prevFile => [...prevFile, ...Array.from(droppedFiles)])
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const fileInputRef = useRef(null);
    const handleBrowseClick = () => {
        fileInputRef.current.click();
    };

    const detectForFile = async (file) => {
        setLoad(true);
        setDisplayPdf(file)
        setAwaitingConfirm(true)
        setDetectLoading(true)
        setDetectOpen(true)
        try {
            const formData = new FormData();
            formData.append("file", file, file.name);
            const { data, error } = await PostPDF(formData, "broylesllc/detect-invoice-supplier");
            if (error || !data) {
                setDetectOpen(false)
                setAwaitingConfirm(false)
                setOpenTestSnack({ color: "error", message: `Could not detect supplier for ${file.name}`, open: true });
                setCurrentFileIndex(prev => prev + 1);
                return;
            }
            setDetection(data)
        } catch (err) {
            console.log(err)
            setDetectOpen(false)
            setAwaitingConfirm(false)
            setCurrentFileIndex(prev => prev + 1);
        } finally {
            setDetectLoading(false)
        }
    }

    const handleConfirmSupplier = async (config) => {
        setDetectOpen(false)
        setPendingConfig(config)
        const file = pdfFiles[currentFileIndex]
        try {
            const formData = new FormData();
            formData.append("file", file, file.name);
            formData.append("configId", config._id);

            const { data: PDFSuccess, error: PDFError } = await PostPDF(formData, "broylesllc/post-pdf-invoice");
            if (PDFError || !PDFSuccess) {
                setOpenTestSnack({ color: "error", message: "OCR failed.", open: true });
                setAwaitingConfirm(false)
                setCurrentFileIndex(prev => prev + 1);
                return;
            }
            const invoiceRemain = (pdfFiles?.length - 1) - currentFileIndex
            setResponseData({
                pdf: PDFSuccess,
                type: "batch",
                invoiceCount: invoiceRemain,
                importConfig: config,
            })
            setOpenResponseDialog(true)
            setLoad(false)
        } catch (err) {
            console.log(err)
            setAwaitingConfirm(false)
            setCurrentFileIndex(prev => prev + 1);
        }
    }

    const handleCancelDetect = () => {
        setDetectOpen(false)
        setAwaitingConfirm(false)
        setCurrentFileIndex(prev => prev + 1);
    }

    const handleClose = (val) => {
        setOpenResponseDialog(false);
        if (val === "Success") {
            setOpenTestSnack({ color: "success", message: "Invoice added successfully!", open: true });
        } else if (val === "Exists") {
            setOpenTestSnack({ color: "warning", message: "Invoice already exists.", open: true });
        } else if (val === "next" || val === "Next") {
            setOpenTestSnack({ color: "success", message: "Parsing next invoice.", open: true });
        }
        setAwaitingConfirm(false)
        setCurrentFileIndex(prevIndex => prevIndex + 1);
    };

    const startBatchUpload = (e) => {
        e.preventDefault();
        if (pdfFiles.length > 0) {
            setLoad(true);
            setCurrentFileIndex(0);
        } else {
            setOpenTestSnack({ color: "info", message: "Please select files to upload.", open: true });
        }
    };

    const renderDots = () => ".".repeat(processingDots);

    return (
        <div style={{ padding: '0 1%', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '10px' }}>
            <div className='row' style={{
                transition: 'border-color 0.2s, background-color 0.2s',
                borderStyle: 'dashed', width: '350px'
            }}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
                <img
                    src="uploadIcon.svg"
                    alt="Upload Icon"
                    className="d-block mx-auto mb-3 text-secondary"
                    style={{ width: '4rem', height: '4rem' }}
                />
                <p>
                    <span>Drop your files here,</span> or{' '}
                    <button
                        onClick={handleBrowseClick}
                        className="btn btn-link p-0 fw-medium"
                    >
                        click to browse
                    </button>
                </p>
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFile}
                    multiple
                    accept="application/pdf"
                    style={{ display: 'none' }}
                />
            </div>

            <div style={{ height: '100px', overflow: 'scroll', maxWidth: '350px' }}>
                {pdfFiles.length > 0 &&
                    pdfFiles.map((f, ind) => (
                        <div className='row' style={{ marginTop: '15px' }} key={f.name + ind}>
                            <p style={{ margin: '0 0 0 10px' }}>File:<em> {f.name}</em></p>
                        </div>
                    ))
                }
            </div>

            <div style={{ marginTop: '20px' }}>
                <button
                    disabled={pdfFiles.length === 0 || load}
                    className={'submit'}
                    style={{ width: "325px", margin: '0', cursor: "pointer", display: 'flex', justifyContent: 'center', alignItems: 'center ' }}
                    onClick={startBatchUpload}>{load ? (
                        <span>Processing{renderDots()}</span>
                    ) : (
                        "Upload Files"
                    )}
                </button>
            </div>

            <SupplierConfirmDialog
                open={detectOpen}
                detection={detection}
                loading={detectLoading}
                onCancel={handleCancelDetect}
                onConfirm={handleConfirmSupplier}
            />

            <Dialog maxWidth={'lg'} fullWidth open={openResponseDialog} onClose={(val) => handleClose(val)}>
                <div style={{ display: 'flex' }}>
                    <div style={{ width: '50%' }}>
                        <DisplayPdf pdfFile={displayPdf} />
                    </div>
                    <div style={{ width: '50%', borderLeft: 'solid' }}>
                        <InvoiceResponse responseData={responseData} closeDialog={(val) => handleClose(val)} />
                    </div>
                </div>
            </Dialog>

            {openTestSnack.open && <SnackbarEx color={openTestSnack.color} message={openTestSnack.message} open={openTestSnack.open}
                close={() => setOpenTestSnack({ color: "", message: "", open: false })} />}
        </div>
    )
}
